<div mat-dialog-content class="d-flex flex-column align-items-center p-3">
  <h5 class="font-weight-bold mb-4">Choose an Order Type</h5>
  <div class="d-flex justify-content-around w-100 mb-3">
    <button
      class="rounded-lg font-semibold px-4 py-3 mx-2 custom-btn-prepare shadow-sm"
      [ngClass]="{
        'bg-warning text-black': selectedType === OrderTypeEnum.DineIn,
        'bg-light text-dark border': selectedType !== OrderTypeEnum.DineIn
      }"
      (click)="selectOrderType(OrderTypeEnum.DineIn)">
      <i class="fa fa-utensils me-2"></i> <br> Dine In
    </button>
    <button
      class="rounded-lg font-semibold px-4 py-3 mx-2 custom-btn-prepare shadow-sm"
      [ngClass]="{
        'bg-warning text-black': selectedType === OrderTypeEnum.TakeAway,
        'bg-light text-dark border': selectedType !== OrderTypeEnum.TakeAway
      }"
      (click)="selectOrderType(OrderTypeEnum.TakeAway)">
      <i class="fa fa-box me-2"></i> <br> Take Away
    </button>
  </div>
</div>
<hr class="w-100">
<mat-dialog-actions>
  <div class="d-flex justify-content-center align-items-center w-100">
    <button class="btn btn-outline-secondary fw-bold py-2 px-4 mx-2 d-flex align-items-center" mat-dialog-close>
      <i class="fa fa-times-circle me-2"></i>
      Cancel
    </button>
    <button (click)="confirmSelection()"
            class="btn btn-primary fw-bold py-2 px-4 mx-2 d-flex align-items-center">
      <i class="fa fa-check-circle me-2"></i>
      Confirm
    </button>
  </div>
</mat-dialog-actions>
